module.exports = __webpack_public_path__ + "img/cloth_g1_hat_07.29232b19.svg";